import { get, post } from "../AxiosConfig";

const getMessageRoleMappings = (companyId) => {
  return get(`/NotificationConfig/GetMessageRoleMappings?companyId=${companyId}`);
};

const saveMessageRoleMappings = (payload) => {
  return post("/NotificationConfig/SaveMessageRoleMappings", payload);
};

const getUserNotificationPreferences = (companyId) => {
  return get(`/NotificationConfig/GetUserNotificationPreferences?companyId=${companyId}`);
};

const saveBulkUserNotificationPreferences = (payload) => {
  return post("/NotificationConfig/SaveBulkUserNotificationPreferences", payload);
};

const getNotificationDistributionLog = (payload) => {
  return post("/NotificationConfig/GetNotificationDistributionLog", payload);
};

const getShabbatSettings = () => {
  return get("/NotificationConfig/GetShabbatSettings");
};

const saveShabbatSettings = (data) => {
  return post("/NotificationConfig/SaveShabbatSettings", data);
};

const sendMessageToUsers = (payload) => {
  return post("/NotificationConfig/SendMessageToUsers", payload);
};

const getWhatsAppOptInStatus = (companyId) => {
  return get(`/NotificationConfig/whatsapp-optin-status?companyId=${companyId}`);
};

const getScheduledMessages = (companyId) => {
  return get(`/NotificationConfig/scheduled-messages?companyId=${companyId}`);
};

const cancelScheduledMessage = (companyId, messageId) => {
  return post("/NotificationConfig/cancel-scheduled-message", { companyId: parseInt(companyId), messageId });
};

const NotificationConfigService = {
  getMessageRoleMappings,
  saveMessageRoleMappings,
  getUserNotificationPreferences,
  saveBulkUserNotificationPreferences,
  getNotificationDistributionLog,
  getShabbatSettings,
  saveShabbatSettings,
  sendMessageToUsers,
  getWhatsAppOptInStatus,
  getScheduledMessages,
  cancelScheduledMessage,
};

export default NotificationConfigService;
